import getAPIUrl from '../../config';
import { getApi } from '../../utils/apiCalls';
import removeFalsyValues from '../../utils/customMethods';
import { PendingApiProps, ResolvedApiProps } from './types';

const getPendingRequests = async (data?: PendingApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/admins/member-requests`,
            data
                ? removeFalsyValues({
                      size: data.pendingSize,
                      page: data.pendingPage,
                      sort: data.sort,
                      order: data.order,
                      name: data.pendingSearchText,
                      isPending: true,
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export const getResolvedRequests = async (data?: ResolvedApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/admins/member-requests`,
            data
                ? removeFalsyValues({
                      size: data.resolvedSize,
                      page: data.resolvedPage,
                      sort: data.sort,
                      order: data.order,
                      name: data.resolvedSearchText,
                      isPending: false,
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export default getPendingRequests;
